import PingumIcon from '../images/icon-with-padding.png';
import store from '../redux/store';

export const getUser = (user, barnUsersMap = store.getState().barn.barnUsersMap) => {
  if (user.auth0UserId === 'Questri' || user.email === 'noreply@questri.app') {
    return {
      ...user,
      avatar: PingumIcon,
      userFullName: 'Questri System',
    };
  }
  if (barnUsersMap[user.auth0UserId]) {
    return barnUsersMap[user.auth0UserId][0];
  }
  if (barnUsersMap[user.email]) {
    return barnUsersMap[user.email][0];
  }
  return user;
};

export const getHighestRole = (roles = []) => {
  if (roles.includes('owner')) return 'Owner';
  if (roles.includes('admin')) return 'Admin';
  if (roles.includes('staff')) return 'Staff';
  if (roles.includes('veterinarian')) return 'Veterinarian';
  if (roles.includes('farrier')) return 'Farrier';
  return 'Client';
}

export const getHighestRoleColor = (roles = []) => {
  if (roles.includes('owner')) return 'primary';
  if (roles.includes('admin')) return 'primary';
  if (roles.includes('staff')) return 'primary';
  return undefined;
}

export const getHighestRoleCompColor = (roles = []) => {
  if (roles.includes('owner')) return undefined;
  if (roles.includes('admin')) return undefined;
  if (roles.includes('staff')) return undefined;
  return undefined;
}
